import { useLocation } from 'react-router-dom';
import { extractPathSegments } from '../utils/url';

/**
 * Hook that returns the path segments from the current URL
 * Empty segments are filtered out
 */
export const usePathSegments = (): string[] => {
  const location = useLocation();

  return extractPathSegments(location.pathname);
};
